export enum CodStatus {
  REALIZADA = 'REALIZADA',
  EN_PROCESO = 'EN_PROCESO',
}

export const tagStatusDictionary = {
  REALIZADA: 'completed',
  EN_PROCESO: 'pending',
};
